import { KanbanTaskType, TasksDashboardFilterKey, TasksDashboardFilters } from "../../../../../widget";
import { TasksDashboardQueryFilters } from "../models";

/**
 * The dashboard header's filter selections, expressed as the widget's four keys. Each is the list of
 * option *keys* the page supplied — uuids for assignee / object / tag — so they can be handed straight
 * back to the query filter. An unset filter is an empty list, which is what the header renders as no
 * selection.
 */
export const toWidgetFilters = (filters: TasksDashboardQueryFilters): TasksDashboardFilters => ({
  assignee: filters.assigneeUuids ?? [],
  taskType: filters.taskTypes ?? [],
  objectName: filters.parentObjectUuids ?? [],
  tag: filters.tagUuids ?? [],
});

/** The query-filter field each header filter drives. */
const QUERY_FILTER_KEY: Record<TasksDashboardFilterKey, keyof TasksDashboardQueryFilters> = {
  assignee: "assigneeUuids",
  taskType: "taskTypes",
  objectName: "parentObjectUuids",
  tag: "tagUuids",
};

/**
 * One header selection folded into the shared query filter. An empty selection — what the dropdown's
 * "Clear all" row reports — clears that filter rather than matching on an empty list.
 */
export const applyWidgetFilter = (
  filters: TasksDashboardQueryFilters,
  key: TasksDashboardFilterKey,
  values: string[]
): TasksDashboardQueryFilters => ({
  ...filters,
  [QUERY_FILTER_KEY[key]]: values.length === 0 ? null : (values as KanbanTaskType[]),
});
